import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-picker maz-p-2 maz-flex maz-justify-end maz-border-top maz-border-top-solid maz-border-color" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, " check ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MazBtn = _resolveComponent("MazBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasNow)
      ? (_openBlock(), _createBlock(_component_MazBtn, {
          key: 0,
          size: "mini",
          tabindex: "-1",
          color: _ctx.color,
          class: "footer-picker__now maz-bg-transparent maz-no-shadow maz-px-3 maz-hover-bg-color maz-no-focus-bg maz-border maz-border-color",
          onClick: _ctx.now
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.nowTranslation), 1)
          ]),
          _: 1
        }, 8, ["color", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.hasValidate)
      ? (_openBlock(), _createBlock(_component_MazBtn, {
          key: 1,
          outline: "",
          size: "mini",
          tabindex: "-1",
          disabled: !_ctx.currentValue,
          color: "success",
          class: "footer-picker__validate",
          onClick: _ctx.validate
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}